import serviceAccounts from '@/apis/coreIAM/serviceAccounts'
import { serviceAccountsTypes } from '@/store/mutationTypes'

export default {
    state: {
        getDefaultScopes: {
            pending: false,
            error: null,
        },
        addDefaultScope: {
            pending: false,
            error: null,
        },
        removeDefaultScope: {
            pending: false,
            error: null,
        },
        getOptionalScopes: {
            pending: false,
            error: null,
        },
        addOptionalScope: {
            pending: false,
            error: null,
        },
        removeOptionalScope: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_REQUEST]: function (state) {
            state.getDefaultScopes.pending = true;
        },
        [serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS]: function (state) {
            state.getDefaultScopes.error = null;
            state.getDefaultScopes.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE]: function (state, error) {
            state.getDefaultScopes.error = error;
            state.getDefaultScopes.pending = false;
        },
        [serviceAccountsTypes.ADD_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.addDefaultScope.pending = true;
        },
        [serviceAccountsTypes.ADD_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.addDefaultScope.error = null;
            state.addDefaultScope.pending = false;
        },
        [serviceAccountsTypes.ADD_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.addDefaultScope.error = error;
            state.addDefaultScope.pending = false;
        },
        [serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.removeDefaultScope.pending = true;
        },
        [serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.removeDefaultScope.error = null;
            state.removeDefaultScope.pending = false;
        },
        [serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.removeDefaultScope.error = error;
            state.removeDefaultScope.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST]: function (state) {
            state.getOptionalScopes.pending = true;
        },
        [serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS]: function (state) {
            state.getOptionalScopes.error = null;
            state.getOptionalScopes.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE]: function (state, error) {
            state.getOptionalScopes.error = error;
            state.getOptionalScopes.pending = false;
        },
        [serviceAccountsTypes.ADD_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.addOptionalScope.pending = true;
        },
        [serviceAccountsTypes.ADD_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.addOptionalScope.error = null;
            state.addOptionalScope.pending = false;
        },
        [serviceAccountsTypes.ADD_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.addOptionalScope.error = error;
            state.addOptionalScope.pending = false;
        },
        [serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.removeOptionalScope.pending = true;
        },
        [serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.removeOptionalScope.error = null;
            state.removeOptionalScope.pending = false;
        },
        [serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.removeOptionalScope.error = error;
            state.removeOptionalScope.pending = false;
        },
    },
    actions: {
        async getDefaultScopes({ commit }, payload) {
            commit(serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .getDefaultScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addDefaultScope({ commit }, payload) {
            commit(serviceAccountsTypes.ADD_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts.addDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(serviceAccountsTypes.ADD_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(serviceAccountsTypes.ADD_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeDefaultScope({ commit }, payload) {
            commit(serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts.removeDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(serviceAccountsTypes.REMOVE_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async getOptionalScopes({ commit }, payload) {
            commit(serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .getOptionalScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addOptionalScope({ commit }, payload) {
            commit(serviceAccountsTypes.ADD_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts.addOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(serviceAccountsTypes.ADD_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(serviceAccountsTypes.ADD_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeOptionalScope({ commit }, payload) {
            commit(serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts.removeOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(serviceAccountsTypes.REMOVE_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
    }
}